'use client';

import { useTranslation } from '../i18n/TranslationContext';
import HeadingBlock from '@/components/builder/HeadingBlock/HeadingBlock';

const content404 = {
  header: '404 Not Found',
  subheader: `Oops… It looks like the page you’re looking for can’t be found.`,
  image: {
    src: '/images/pistachios_shell-noshell.png',
    altText: '',
  },
};

export const NotFoundClient = () => {
  const { t } = useTranslation();

  const headingBlockContent = {
    header: t(content404.header),
    subheader: t(content404.subheader),
    image: content404.image,
  };

  return (
    <>
      <div className="container" style={{ marginBottom: '60px' }}>
        <div className="row">
          <div className="col-12">
            <HeadingBlock {...headingBlockContent} />
          </div>
        </div>
      </div>
    </>
  );
};
